<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="search">
        <el-input
          v-model="search"
          placeholder="请输入地点名称..."
          @input="searchChange"
        ></el-input>
        <img src="@/assets/logistics/search.png" alt="" />
        <img :src="$store.state.userInfo.icon" alt="" />
      </div>
      <div class="tab">
        <div
          class="tab_item"
          @click="cilckTab(0)"
          :class="tabIndex == 0 ? 'active' : ''"
        >
          借伞申请
        </div>
        <div
          class="tab_item"
          @click="cilckTab(1)"
          :class="tabIndex == 1 ? 'active' : ''"
        >
          申请记录
        </div>
      </div>
      <div class="list" v-if="tabIndex == 0 && list.length > 0">
        <div class="list_item" v-for="(item, index) in list" :key="index">
          <div class="top">
            <!-- <img v-if="item.image" :src="imgUrl + item?.image" alt="" /> -->
            <img src="@/assets/logistics/location/umbrella.png" alt="" />
            <div class="top_right">
              <div class="top_title">{{ item.place }}</div>
              <div class="top_number">
                可借：<span>{{
                  (item.stock ? item.stock : 0) -
                  (item.lendNum ? item.lendNum : 0)
                }}</span>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="content">存放地点：{{ item.address }}</div>
          <div
            class="btn"
            @click="
              toUrlApply(
                (path =
                  '/logistics/borrowingAnUmbrella/borrowingAnUmbrellaApply'),
                item
              )
            "
          >
            借伞
          </div>
        </div>
      </div>
      <div class="list" v-else-if="tabIndex == 1 && list.length > 0">
        <div
          class="list_item"
          v-for="(item, index) in list"
          :key="index"
          @click="
            toUrl(
              (path =
                '/logistics/borrowingAnUmbrella/borrowingAnUmbrellaReturn'),
              item
            )
          "
        >
          <div class="top">
            <!-- <img src="@/assets/logistics/location/umbrella.png" alt="" /> -->
            <!-- <img v-if="item.image" :src="imgUrl + item?.image" alt="" /> -->
            <img src="@/assets/logistics/location/umbrella.png" alt="" />
            <div class="top_right">
              <div class="top_title" style="font-size: 20px">
                已借：X<span>{{ item.num }}</span>
              </div>
              <div class="top_state top_state1" v-if="item.state == 1">
                未归还
              </div>
              <div class="top_state top_state2" v-if="item.state == 2">
                已归还
              </div>
              <div class="top_state top_state3" v-if="item.state == 3">
                异常
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="content">借用时间：{{ item.buTime }}</div>
          <div class="content">归还地点：{{ item.place }}</div>
          <div class="btn" v-if="item.state == 1">还伞</div>
        </div>
      </div>
      <div class="kong_con" v-else>
        <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
        <div class="kong_title kong_title1">暂无数据</div>
      </div>
      <img
        v-if="showBackend"
        class="backendIcon"
        src="@/assets/logistics/backendIcon.png"
        alt=""
        @click="toBackend"
      />
    </div>
  </div>
</template>

<script>
import apis from "@/apis/borrowingAnUmbrella";
import api from "@/apis/medal";
import { getToken } from "@/utils/cookie";
import moment from "moment";
import { redirectRoute } from "@/utils/tools";
export default {
  components: {},
  data() {
    return {
      search: "",
      list: [],
      tabIndex: 0,
      showBackend: false,
      imgUrl: "",
    };
  },
  mounted() {
    this.imgUrl = api.imgUrl;
    const { type } = this.$route.query;
    if (type) {
      if (type == 1) {
        this.tabIndex = 0;
      } else {
        this.tabIndex = 1;
      }
    }
    // this.redirect();
    let token = getToken();
    if (token) {
      this.redirect(token);
    } else {
      this.$bus.$on("processToken", (res) => {
        this.redirect(res);
      });
    }
  },
  methods: {
    searchChange() {
      if (this.tabIndex == 0) {
        this.getListApply();
      } else {
        this.getListReturn();
      }
    },
    //状态控制
    redirect(res) {
      if (this.tabIndex == 0) {
        this.getListApply();
      } else {
        this.getListReturn();
      }
      if (
        ( res == "10005038" ||
          res == "10008797" ||
          res == "10008704" ||
          res == "10005818" ||
          res == "10008520" ||
          res == "10003948" ) &&
        redirectRoute()
      ) {
        this.showBackend = true;
      }
    },
    //跳转借伞管理
    toBackend() {
      this.$router.push("/borrowingAnUmbrella/backend/borrowAndReturn");
    },
    //获取借伞列表
    getListApply() {
      apis.stockList({ name: this.search }).then((res) => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
    //获取借伞记录列表
    getListReturn() {
      apis
        .myRecordList({
          empNo: getToken(),
          name: this.search,
        })
        .then((res) => {
          if (res.code == 200) {
            this.list = res.data;
            this.list.length > 0 &&
              this.list.forEach((item) => {
                item.buTime = moment(item.buTime).format("YYYY-MM-DD HH:mm");
                item.planTime = moment(item.planTime).format(
                  "YYYY-MM-DD HH:mm"
                );
                item.disposeTime = moment(item.disposeTime).format(
                  "YYYY-MM-DD HH:mm"
                );
              });
          }
        });
    },
    //点击tab
    cilckTab(type) {
      this.tabIndex = type;
      if (type == 0) {
        this.getListApply();
      } else {
        this.getListReturn();
      }
    },
    //跳转
    toUrlApply(path, item) {
      this.$router.push({
        path: path,
        query: {
          id: item.id,
        },
      });
    },
    //跳转
    toUrl(path, item) {
      console.log(item, "item");

      this.$router.push({
        path: path,
        query: {
          item: JSON.stringify(item),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 276px * $zoom;
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding-top: 40px;
  background: #f7f9fa;
  .search {
    background: #fff;
    border-radius: 40px;
    padding: 0 0 0 20px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    img {
      width: 55px;
      height: 55px;
      margin-right: 32px;
    }
    img:nth-child(3) {
      border-radius: 50%;
    }
    ::v-deep {
      .el-input {
        height: 100%;
      }
      .el-input__inner {
        height: 100%;
        background: #fff;
        border: none;
        font-size: 32px;
        color: rgba(125, 133, 146, 1);
      }
    }
  }
  .tab {
    background: #ebeeef;
    border-radius: 100px;
    color: #282b32;
    font-size: 30px;
    display: flex;
    align-items: center;
    height: 80px;
    width: 90%;
    margin: 30px auto 0;
    .tab_item {
      width: 50%;
      height: 100%;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .active {
      background: #4ea27c;
      color: #fff;
    }
  }
  .list {
    width: 90%;
    margin: 30px auto 0;
    overflow: auto;
    height: calc(100vh - 330px);
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
    .list_item:nth-child(1) {
      margin-top: 0 !important;
    }
    .list_item {
      background: #fff;
      border-radius: 40px;
      padding: 30px;
      margin-top: 30px;
      .top {
        display: flex;
        align-items: center;
        position: relative;
        img {
          width: 100px;
          height: 100px;
          border-radius: 20px;
        }
        .top_right {
          margin-left: 30px;
          color: #282b32;
          font-size: 30px;
          .top_title {
            font-weight: bold;
          }
          .top_number {
            color: #969b9e;
            font-size: 29px;
            margin-top: 12px;
            span {
              color: #4ea27c;
            }
          }
          .top_state {
            position: absolute;
            font-size: 28px;
            padding: 10px 20px;
            border-radius: 10px;
            top: 0;
            right: 0;
          }
          .top_state1 {
            color: #fe964a;
            background: #fff0e6;
          }
          .top_state2 {
            color: #0caf60;
            background: #e7f7ef;
          }
          .top_state3 {
            color: #fd6a6a;
            background: #fff0f0;
          }
        }
      }
      .line {
        width: 100%;
        height: 2px;
        background: #e4e6e8;
        margin: 35px 0 30px 0;
      }
      .content {
        color: #969b9e;
        font-size: 30px;
        margin-bottom: 30px;
      }
      .btn {
        color: #4ea27c;
        width: 100%;
        height: 86px;
        border-radius: 30px;
        font-size: 30px;
        border: 1px solid #4ea27c;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.kong_con {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  justify-content: center;
  .kong_img {
    width: 450px;
    height: 450px;
  }
  .kong_title1 {
    margin-top: 30px !important;
  }
  .kong_title {
    color: #999999;
    font-size: 26px;
    margin-top: 10px;
  }
}
.backendIcon {
  position: absolute;
  right: 20px;
  bottom: 110px;
  width: 150px;
  height: 150px;
}
</style>
